/**
 * @file 创意机会迁移提示卡片 - 侧边栏 footer hook
 * @description is_creative_assets_enable 已全量上线，
 *              判断"角色白名单 + 当前路径是否处于机会导航下"，
 *              仅当判断通过时才返回 <CreativeMigrationTip />，否则返回 undefined。
 *              调用方（如 useMicroApp）无需关心具体业务规则，拿到非空 footer 才注入即可。
 */

import React, { useMemo } from 'react';

import globalStore from '@/stores';
import { isCreativeAssetsEnable } from '@/common/menus/utils';
import CreativeMigrationTip from './index';

// 收集"机会"顶级导航下所有子孙 href
const collectHrefs = (node: any, set: Set<string>) => {
  if (node?.href) set.add(node.href);
  (node?.data || []).forEach((child: any) => collectHrefs(child, set));
};

export default function useCreativeMigrationFooter(pathname: string): React.ReactNode | undefined {
  return useMemo(() => {
    // is_creative_assets_enable 已全量上线，仅保留角色白名单判断
    const account = globalStore.account || {};
    if (!isCreativeAssetsEnable(account)) {
      return undefined;
    }

    const siteMap: any = globalStore.account?.siteMap || {};
    const navMenu: any[] = siteMap.navMenu || [];
    const oppotunityTop = navMenu.find((item) => item.key === 'oppotunity_manage');

    const oppotunityHrefs = new Set<string>();
    if (oppotunityTop) collectHrefs(oppotunityTop, oppotunityHrefs);

    const isOppotunityNav = oppotunityHrefs.has(pathname)
      || Array.from(oppotunityHrefs).some((h) => pathname.startsWith(h));

    if (!isOppotunityNav) {
      return undefined;
    }

    return <CreativeMigrationTip />;
  }, [pathname, globalStore?.account, globalStore.account?.siteMap]);
}
